export default "__VITE_ASSET__U23CXSg8__"